ui-cms-stock-indices {
  display: block;
  container-type: inline-size;

  sd-spinner {
    font-size: $sd-fontSize-3xl;
  }

  .stock-indices-wrapper {
    &__content {
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .content-container {
        display: block;

        @container (min-width: #{$medium}) {
          display: flex;
          align-items: top;
          margin-top: $sd-spacing-4;
        }

        .stock-title {
          margin: 0;
          font-size: $sd-fontSize-base;

          @container (min-width: #{$medium}) {
            font-size: $sd-fontSize-xl;
          }

          .stock-price-mobile {
            font-weight: $font-weight-bold;

            @container (min-width: #{$medium}) {
              display: none;
            }
          }
        }

        .stock-price {
          margin: 0;
          color: $sd-textColor-primary-DEFAULT;
          font-size: $sd-fontSize-4xl;
          font-weight: $font-weight-bold;
          line-height: normal;
          display: none;

          @container (min-width: #{$medium}) {
            display: block;
          }
        }

        .stock-date {
          margin: 0;
        }

        .stock-balance {
          font-weight: $font-weight-bold;
          margin-left: $sd-spacing-1;

          @container (min-width: #{$medium}) {
            display: inline-block;
          }
        }

        &__column-info {
          width: 100%;
          margin: $sd-spacing-4 0;

          @container (min-width: #{$medium}) {
            width: 30%;
            padding-right: $sd-spacing-6;
            margin: 0;
          }

          @container (min-width: #{$desktop}) {
            padding-right: $sd-spacing-4;
          }
        }

        &__column-chart {
          width: 100%;

          @container (min-width: #{$medium}) {
            width: 70%;
            padding-left: $sd-spacing-6;
          }

          @container (min-width: #{$desktop}) {
            padding-left: $sd-spacing-4;
          }
        }
      }
    }

    &__actions {
      margin-top: $sd-spacing-3;
      order: 1; // below the chart on mobile

      sd-button {
        float: right;
      }

      sd-radio-group {
        overflow: auto;
      }

      @container (min-width: #{$medium}) {
        order: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-height: 48px;

      &-preview {
        display: flex;

        .stock-indices-wrapper__header-item {
          margin-right: $sd-spacing-6;
          display: flex;

          &:nth-child(n + 2) {
            display: none;
          }

          @container (min-width: #{$medium}) {
            &:nth-child(n + 2) {
              display: flex;
            }

            &:nth-child(n + 3) {
              display: none;
            }
          }

          @container (min-width: #{$desktop}) {
            &:nth-child(n + 3) {
              display: flex;
            }
          }

          .header-item-amount {
            font-weight: $font-weight-bold;
            margin: 0 $sd-spacing-2;
          }
        }
      }

      sd-icon {
        font-size: $sd-fontSize-xl;
      }
    }

    .stock-balance {
      margin: 0;

      &.positive {
        color: $sd-textColor-accent;
      }

      &.negative {
        color: $sd-textColor-error;
      }
    }

    .stock-last-day {
      margin: 0;
    }
  }

  .overlay {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    background: rgba($color: #fff, $alpha: 80%);

    sd-spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
}
